import { render, staticRenderFns } from "./CMAttachmentsList.vue?vue&type=template&id=22596156&scoped=true&"
import script from "./CMAttachmentsList.vue?vue&type=script&lang=js&"
export * from "./CMAttachmentsList.vue?vue&type=script&lang=js&"
import style0 from "./CMAttachmentsList.vue?vue&type=style&index=0&id=22596156&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22596156",
  null
  
)

export default component.exports